module.exports = __webpack_public_path__ + "static/media/me@3000x1688.988bfd9d.jpg";